<template>
  <form-inline
    :outdated="attempt.replaced_by_proposal_attempt_id"
    :current="attempt.bank_proposal_identifier"
    :loading="loading"
    :class="classes"
    @submit="submit"
  />
</template>

<script>
  import { mapState } from 'vuex';

  import FormInline from '@cordel/components/Form/Inline.vue';

  export default {
    name: 'ProposalsReadCode',
    components: {
      FormInline,
    },
    props: {
      proposal: {
        type: Object,
        default() {
          return {};
        },
      },
      attempt: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    computed: {
      ...mapState([
        'proposalAttempts',
      ]),
      loading() {
        return this.proposalAttempts.update.loading;
      },
      classes() {
        const classes = ['proposals-read-code'];

        if (this.attempt.replaced_by_proposal_attempt_id) {
          classes.push('outdated-label-class');
        }

        return classes;
      },
    },
    mounted() {
      this.$store.dispatch('proposalAttempts/clear', {
        action: 'update',
      });
    },
    methods: {
      submit(code) {
        if (!code) {
          return;
        }

        this.$store.dispatch('proposalAttempts/update', {
          proposal_id: this.proposal.id,
          id: this.attempt.id,
          bank_proposal_identifier: code,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .proposals-read-code {
  }

  .outdated-label-class {
    color: var(--cordel-color-neutral-primary);
  }
</style>
